// extracted by mini-css-extract-plugin
export var indeterminate = "_5l-5";
export var md = "_5l-4";
export var semantic = "_5l-6";
export var sm = "_5l-3";
export var text = "_5l-7";
export var toggleInput = "_5l-0";
export var toggleSwitch = "_5l-1";
export var xs = "_5l-2";